export default {
	accounts             : 'accounts',
	token                : 'token',
	agencyOverview       : 'AgencyOverview',
	applications         : 'applications',
	organizations        : 'organizations',
	jurisdictionFees     : 'jurisdictionfees',
	clientOverview       : 'clientOverview',
	clients              : 'clients',
	projects             : 'projects',
	jobEvents            : 'jobEvents',
	jobs                 : 'jobs',
	officers             : 'officer',
	externalOfficers     : 'externalOfficer',
	contacts             : 'contacts',
	locations            : 'locations',
	locationGroups       : 'locationgroup',
	locationTypes        : 'locationtypes',
	jobEstimates         : 'Jobeventinvoiceestimate',
	jurisdictionLocation : 'jurisdictionLocationApproval',
	jurisdictionApproval : 'jurisdictionJobAssignmentApproval',
	jurisdictions        : 'jurisdictions',
	jurisdictionRules    : 'jurisdictionrules',
	tasks                : 'tasks',
	jobNotifications     : 'jobNotificationSettings',
	checkIns             : 'checkins',
	USStates             : 'states',
	organizationExtended : 'organizationExtended',
	officerRanks         : 'officerRanks',
	officerOverview      : 'officeroverview',
	notes                : 'notes',
	paymentTerms         : 'paymentterms',
	payouts              : 'payouts',
	posts                : 'posts',
	invitations          : 'invitations',
	stats                : 'stats',
	counts               : 'counts',
	payments             : 'payments',
	paymentMethods       : 'paymentmethods',
	invoices             : 'invoices',
	groups               : 'organizationfavoritegroups',
	favoriteOfficers     : 'organizations/officers',
	timeZones            : 'timeZones',
	jobEventTypes        : 'jobeventtypes',
	vehicleTypes         : 'vehicletypes',
	dressTypes           : 'dresstypes',
	shifts               : 'jurisdictionshift',
	agencyRestrictions   : 'organizationofficerconstraints',
	signUp               : 'signup',
	plaid                : 'plaid',
	taxExemptions        : 'taxexemptions',
	clientjobrequest     : 'clientjobrequest',
	officerRating        : 'officerratings',
};
